<template>
  <div class="phy_wrap">
    <div v-if="!showDetail">
      <div class="statuslist">
        <div v-for="item in statuslist" class="ristStatus">
          {{ item.name }}
        </div>
      </div>
      <div class="graphBox" v-for="(item, index) in diseaseList" :key="index">
        <div class="graph">
          <div class="graph-title">{{ item.name }}<span :class="'col' + item.lev">{{ item.ts }}</span></div>
          <div class="bar">
            <div :class="'level' + item.lev" class="barBg" :style="{ width: item.a + '%' }"></div>
          </div>

        </div>
        <div class="graphBtton">
          <span class="graphBttonBt">{{ item.a }}%</span>
          <span class="graphBttonLink" @click="toDetails(item)">查看</span>
        </div>
      </div>
    </div>
    <template v-if="showDetail">
      <div class="details">
        <div class="dis-top">
          <div class="back" @click="
            showDetail = false;
          details = {};
                        ">
            返回
          </div>
          <div class="text">
            <p>{{ details.name }}</p>
            ({{ details.ts == '正常' ? details.ts : '有' + details.ts + '风险' }})
          </div>
        </div>
        <div class="dis_title">
          <img src="../assets/image/disease/dis-icon1.png" />
          <span>疾病介绍</span>
        </div>
        <div class="jy" v-for="text in details.introduce" :key="text">
          {{ text }}
        </div>
        <div class="dis_title">
          <img src="../assets/image/disease/dis-icon3.png" />
          <span>病因</span>
        </div>
        <div class="jy" v-for="text in details.etiology" :key="text">
          {{ text }}
        </div>
        <div class="dis_title">
          <img class="icon" src="../assets/image/disease/dis-icon2.png" />
          <span>疾病预防</span>
        </div>
        <div class="jy" v-for="text in details.prevention" :key="text">
          {{ text }}
        </div>
      </div>
    </template>
  </div>
</template>
<script>

import { ossUrl } from "@/config";
export default {
  props: ['list'],
  components: {},
  data() {
    return {
      ossUrl,
      diseaseList: [],
      level: '',
      details: {},
      statuslist: [{ name: '正常', id: 1 },
      { name: '潜在', id: 2 },
      { name: '偏高', id: 3 },
      { name: '较高', id: 4 },
      { name: '极高', id: 5 }],
      showDetail: false,
    }
  },
  created() {
    try {
      this.list.nzz.introduce = this.list.nzz.introduce.replace('\\“脑卒中\\”','脑卒中')
    } catch (error) {
      
    }
    this.hanldeObJToArr(this.list)
  },
  methods: {
    toDetails(item) {
      document.documentElement.scrollTop = 0
      this.showDetail = true;
      this.details = item
    },
    hanldeObJToArr(obj) {
      const arr = []
      for (let key in obj) {
        arr.push(
          {
            ...obj[key],
            title: key
          })
      }
      arr.forEach(e => {
        if (e.a >= 0 && e.a <= 19) {
          e.lev = 1
          e.ts = '正常'
        } else if (e.a >= 20 && e.a <= 39) {
          e.lev = 2
          e.ts = '潜在'
        } else if (e.a >= 40 && e.a <= 59) {
          e.lev = 3
          e.ts = '偏高'
        } else if (e.a >= 60 && e.a <= 79) {
          e.lev = 4
          e.ts = '较高'
        } else if (e.a >= 80 && e.a <= 100) {
          e.lev = 5
          e.ts = '极高'
        }
        e.introduce = e.introduce ? e.introduce.split('\\r\\n') : []
        e.prevention = e.prevention ? e.prevention.split('\\r\\n') : []
        e.etiology = e.etiology ? e.etiology.split('\\r\\n') : []
      })
      this.diseaseList = arr
    },
  },
}
</script>
<style lang="scss" scoped>
.phy_wrap {
  position: relative;
  width: 100%;
  margin: 20px auto 0 auto;

  .statuslist {
    display: flex;
    width: 100%;
    background: #fff;
    padding:20px 15px;
    box-sizing: border-box;
    margin-bottom: 20px;
  }

  .statuslist .ristStatus {
    width: 20%;
    height: 60px;
    line-height: 60px;
    color: #fff;
    background-color: #B5B5B5;
    border-left: 1px solid #fff;
    font-size: 28px;
    text-align: center;
  }
  .ristStatus:nth-child(1) {
    background-color: #009944;
  }
  .ristStatus:nth-child(2) {
    background-color: #FEAE63;
  }

  .ristStatus:nth-child(3) {
    background-color: #F29238;
  }

  .ristStatus:nth-child(4) {
    background-color: #DD352A;
  }

  .ristStatus:nth-child(5) {
    background-color: #A01D18;
  }

 
  .graphBox {
    padding: 20px;
    display: flex;
    background-color: #fff;
    margin-bottom: 20px;

    .graph {
      position: relative;
      width: 70%;

      .bar {
        display: block;
        position: relative;
        background: #bfc1ca;
        height: 20px;
        border-radius: 10px;
        overflow: hidden;

        .barBg {
          background: red;
          display: block;
          height: 20px;
        }

        .level1 {
          background: #039844;
        }

        .level2 {
          background: #faae62;
        }

        .level3 {
          background: #ed943c;
        }

        .level4 {
          background: #dd3425;
        }

        .level5 {
          background: #a01d18;
        }
      }

      .graph-title {
        font-size: 32px;
        margin-bottom: 10px;
        text-align: left;

        span {
          font-size: 24px;
          display: inline-block;
          margin-left: 15px;
          float: right;
          margin-top: 10px;
          font-style: italic;
        }

        .col1 {
          color: #039844;
        }

        .col2 {
          color: #faae62;
        }

        .col3 {
          color: #ed943c;
        }

        .col4 {
          color: #dd3425;
        }

        .col5 {
          color: #a01d18;
        }
      }

      .graph-value {}
    }

    .graphBtton {
      margin-top: 42px;
      text-align: right;
      width: 30%;

      .graphBttonBt {
        font-size: 28px;
        color: #9b9b9b;
        width: 60%;
        text-align: center;
        display: inline-block;
      }

      .graphBttonLink {

        width: 40%;
        padding: 5px 0;
        text-align: center;
        background-color: #2E94E5;
        color: #fff;
        font-size: 26px;
        display: inline-block;
        border-radius: 5px;
      }
    }
  }

  .details {
    background: #fff;

    .dis-top {
      position: relative;
      background-image: url(../assets/image/disease/title_bg.png);
      background-size: auto 100%;
      height: 260px;
      width: 100%;

      .back {
        position: absolute;
        top: 20px;
        left: 20px;
        background-color: #fff;
        width: 100px;
        height: 52px;
        border-radius: 4px;
        line-height: 52px;
      }

      .text {
        position: absolute;
        top: 0;
        left: 80px;
        bottom: 0;
        margin: auto 0;
        text-align: center;
        color: #ff4f4f;
        font-weight: bold;
        font-size: 36px;
        height: 100px;

        p {
          font-size: 42px;
          margin: 0;
        }
      }
    }

    .dis_title {
      width: 700px;
      margin: auto;
      font-size: 34px;
      color: #616161;
      margin: 30px auto 25px;
      text-align: left;
      display: flex;
      align-items: center;
      padding: 0 10px;
      color: #000;

      img {
        width: 40px;
        margin-right: 20px;
      }
    }
  }

  .jy {
    width: 700px;
    margin: 0 auto 25px;
    padding: 0 10px;
    text-align: left;
    padding-bottom: 30px;
    border-bottom: 1px dashed #ddd;
  }

  .risk-status {
    margin: 15px auto 0;
    width: 350px;
  }
}</style>